export const cleanUrlTabHash = (str) => {
    return str
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "")
        .trim();
};
// This function will add 'https://' to the beginning of the url if it doesn't exist.
// it will also clean up the url by removing any trailing slashes.
export const cleanUrl = (url) => {
    if (!url)
        return url;
    // Remove any existing protocol prefixes (http://, https://, http:, https:)
    let cleanUrl = url.replace(/^https?:\/\/?/i, "");
    // Add https:// if no protocol is present
    if (cleanUrl && !cleanUrl.match(/^https?:\/\//i)) {
        cleanUrl = `https://${cleanUrl}`;
    }
    return cleanUrl;
};
